<template>
  <div class="footer">
    <div class="foot-v3-pc foot-v3-1-pc">
        <div class="foot-v3-mainbody">
          <div class="foot-v3-logo">
            <a href="https://www.cgtn.com" class="foot-v3-logo-main"></a>
          </div>
          <div class="foot-v3-content">
            <div class="foot-v3-list foot-v3-list-site">
              <ul>
                <li>
                  <a
                    href="https://www.cgtn.com/china"
                    class=""
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Sitemap_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    China
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.cgtn.com/world"
                    class=""
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Sitemap_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    World
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.cgtn.com/politics"
                    class=""
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Sitemap_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Politics
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.cgtn.com/business"
                    class=""
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Sitemap_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Business
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.cgtn.com/sci-tech"
                    class=""
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Sitemap_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Sci-Tech
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.cgtn.com/culture"
                    class=""
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Sitemap_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Culture
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.cgtn.com/sports"
                    class=""
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Sitemap_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Sports
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.cgtn.com/opinions"
                    class=""
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Sitemap_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Opinions
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.cgtn.com/travel"
                    class=""
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Sitemap_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Travel
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.cgtn.com/nature"
                    class=""
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Sitemap_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Nature
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.cgtn.com/picture"
                    class=""
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Sitemap_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Picture
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.cgtn.com/video"
                    class=""
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Sitemap_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Video
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.cgtn.com/live"
                    class=""
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Sitemap_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Live
                  </a>
                </li>
                <li>
                  <a
                    href="https://radio.cgtn.com"
                    class=""
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Sitemap_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Radio
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.cgtn.com/specials"
                    class=""
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Sitemap_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Specials
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.cgtn.com/transcript"
                    class=""
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Sitemap_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Transcript
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.cgtn.com/europe"
                    class=""
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Sitemap_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    EUROPE
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.cgtn.com/special/chinese-master"
                    class=""
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Sitemap_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Learn Chinese
                  </a>
                </li>
                <li>
                  <a 
                    href="https://ask-china.cgtn.com/" 
                    class="" 
                    target="_self" 
                    data-category="sharePage-v3" 
                    data-action="Sitemap_Click" 
                    data-label="" 
                    data-position="" 
                    data-news-id="" 
                    data-time=""
                  >
                    Ask China        
                  </a>
                </li>
              </ul>
            </div>
            <div class="foot-v3-list foot-v3-list-explore">
              <p class="foot-v3-list-title foot-v3-list-title-explore">
                EXPLORE MORE
              </p>
              <ul id="language">
                <li>
                  <a
                    href="https://www.cgtn.com/tv"
                    class=""
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    English
                  </a>
                </li>
                <li>
                  <a
                    href="https://espanol.cgtn.com"
                    class=""
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Español
                  </a>
                </li>
                <li>
                  <a
                    href="https://francais.cgtn.com"
                    class=""
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Français
                  </a>
                </li>
                <li>
                  <a
                    href="https://arabic.cgtn.com"
                    class=""
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    العربية
                  </a>
                </li>
                <li>
                  <a
                    href="https://russian.cgtn.com"
                    class=""
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Русский
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.cgtn.com/channel/documentary"
                    class=""
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Documentary
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.cctvplus.com"
                    class=""
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    CCTV+
                  </a>
                </li>
              </ul>
            </div>
            <div class="foot-v3-list foot-v3-list-language">
              <p class="foot-v3-list-title foot-v3-list-title-language">
                CHOOSE YOUR LANGUAGE
              </p>
              <div class="foot-v3-list-language-con">
                <ul>
                  <li>
                    <a
                      href="https://albanian.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Albanian</span>
                      <span class="foot-v3-language-name2">Shqip</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://arabic.cgtn.com"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Arabic</span>
                      <span class="foot-v3-language-name2">العربية</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://belarusian.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Belarusian</span>
                      <span class="foot-v3-language-name2">Беларуская</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://bangla.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Bengali</span>
                      <span class="foot-v3-language-name2">বাংলা</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://bulgarian.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Bulgarian</span>
                      <span class="foot-v3-language-name2">Български</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://cambodian.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Cambodian</span>
                      <span class="foot-v3-language-name2">ខ្មែរ</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://croatian.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Croatian</span>
                      <span class="foot-v3-language-name2">Hrvatski</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://czech.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Czech</span>
                      <span class="foot-v3-language-name2">Český</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.cgtn.com/tv"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">English</span>
                      <span class="foot-v3-language-name2">English</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://esperanto.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Esperanto</span>
                      <span class="foot-v3-language-name2">Esperanto</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://filipino.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Filipino</span>
                      <span class="foot-v3-language-name2">Filipino</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://francais.cgtn.com"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">French</span>
                      <span class="foot-v3-language-name2">Français</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://german.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">German</span>
                      <span class="foot-v3-language-name2">Deutsch</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://greek.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Greek</span>
                      <span class="foot-v3-language-name2">Ελληνικά</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://hausa.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Hausa</span>
                      <span class="foot-v3-language-name2">Hausa</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://hebrew.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Hebrew</span>
                      <span class="foot-v3-language-name2">עברית</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://hungarian.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Hungarian</span>
                      <span class="foot-v3-language-name2">Magyar</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://hindi.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Hindi</span>
                      <span class="foot-v3-language-name2">हिन्दी</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://indonesian.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Indonesian</span>
                      <span class="foot-v3-language-name2"
                        >Bahasa Indonesia</span
                      >
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://italian.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Italian</span>
                      <span class="foot-v3-language-name2">Italiano</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://japanese.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Japanese</span>
                      <span class="foot-v3-language-name2">日本語</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://korean.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Korean</span>
                      <span class="foot-v3-language-name2">한국어</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://laos.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Lao</span>
                      <span class="foot-v3-language-name2">ລາວ</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://malay.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Malay</span>
                      <span class="foot-v3-language-name2">Bahasa Melayu</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://mongol.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Mongolian</span>
                      <span class="foot-v3-language-name2">Монгол</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://myanmar.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Myanmar</span>
                      <span class="foot-v3-language-name2">မြန်မာဘာသာ</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://nepal.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Nepali</span>
                      <span class="foot-v3-language-name2">नेपाली</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://persian.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Persian</span>
                      <span class="foot-v3-language-name2">فارسی</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://polish.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Polish</span>
                      <span class="foot-v3-language-name2">Polski</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://portuguese.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Portuguese</span>
                      <span class="foot-v3-language-name2">Português</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://pashto.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Pashto</span>
                      <span class="foot-v3-language-name2">پښتو</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://romanian.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Romanian</span>
                      <span class="foot-v3-language-name2">Română</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://russian.cgtn.com"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Russian</span>
                      <span class="foot-v3-language-name2">Русский</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://serbian.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Serbian</span>
                      <span class="foot-v3-language-name2">Српски</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://sinhala.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Sinhalese</span>
                      <span class="foot-v3-language-name2">සිංහල</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://espanol.cgtn.com"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Spanish</span>
                      <span class="foot-v3-language-name2">Español</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://swahili.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Swahili</span>
                      <span class="foot-v3-language-name2">Kiswahili</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://tamil.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Tamil</span>
                      <span class="foot-v3-language-name2">தமிழ்</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://thai.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Thai</span>
                      <span class="foot-v3-language-name2">ไทย</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://turkish.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Turkish</span>
                      <span class="foot-v3-language-name2">Türkçe</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://ukrainian.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Ukrainian</span>
                      <span class="foot-v3-language-name2">Українська</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://urdu.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Urdu</span>
                      <span class="foot-v3-language-name2">اردو</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://vietnamese.cgtn.com/"
                      class=""
                      target="_blank"
                      data-category="Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      <span class="foot-v3-language-name">Vietnamese</span>
                      <span class="foot-v3-language-name2">Tiếng Việt</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="foot-v3-line"></div>
            <div class="foot-v3-list foot-v3-list-down">
              <p class="foot-v3-list-title foot-v3-list-title-down">DOWNLOAD OUR APP</p>
              <ul>
                <li>
                  <a
                    href="https://itunes.apple.com/us/app/cctvnews/id922456579"
                    class="downicon apple"
                    target="_blank"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Download_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                  </a>
                </li>
                <li>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.imib.cctv"
                    class="downicon google"
                    target="_blank"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Download_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                  </a>
                </li>
                <li>
                  <a
                    href="https://news.cgtn.com/download/CGTN.apk"
                    class="downicon web"
                    target="_blank"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Download_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.cgtn.com/appletv-download"
                    class="downicon apple-tv"
                    target="_blank"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Download_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                  </a>
                </li>
              </ul>
            </div>
            <div class="foot-v3-list foot-v3-list-items">
              <ul>
                <li>
                  <a
                    href="https://www.cgtn.com/terms-of-use"
                    class=""
                    target="_self"
                    data-category="Home"
                    data-list=""
                    data-action="TeamOfUs_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Terms of use
                  </a>
                  <span class="hr-r"></span>
                </li>
                <li>
                  <a
                    href="https://www.cgtn.com/copyright"
                    class=""
                    target="_self"
                    data-category="Home"
                    data-list=""
                    data-action="Copyright_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Copyright
                  </a>
                  <span class="hr-r"></span>
                </li>
                <li>
                  <a
                    href="https://www.cgtn.com/privacy"
                    class="pdr0"
                    target="_self"
                    data-category="Home"
                    data-list=""
                    data-action="PrivacyPolicy_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Privacy policy
                  </a>
                  <span class="hr-r"></span>
                </li>
                <li>
                  <a
                    href="https://www.cgtn.com/about-us"
                    class=""
                    target="_self"
                    data-category="Home"
                    data-list=""
                    data-action="AboutUs_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    About us
                  </a>
                </li>
              </ul>
            </div>
            <div class="foot-v3-list foot-v3-list-copy">
              <div class="foot-v3-copy-right">
                <div class="foot-v3-copy-right-text">
                  Copyright © 2024 CGTN.
                </div>
                <a
                  class="foot-v3-copy-right-link"
                  href="http://beian.miit.gov.cn"
                  target="_blank"
                  >京ICP备20000184号</a
                >
              </div>
              <div class="foot-v3-copy-common foot-v3-copy-anbei">
                <a
                  class="foot-v3-copy-anbei-con"
                  href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502050052"
                  target="_blank"
                >
                  <img
                    src="https://ui.cgtn.com/static/ng/resource/images/gwab.png"
                    class="gwab-img-v3"
                  />
                  <span class="jgwab-num-v3">京公网安备 11010502050052号</span>
                </a>
                <p class="foot-v3-copy-hotline foot-v3-network-num">互联网新闻信息许可证10120180008</p>
                <p class="foot-v3-copy-hotline">
                  Disinformation report hotline: 010-85061466
                </p>
              </div>
              
            </div>
          </div>
        </div>
      </div>
      <div class="foot-v3-m">
        <div class="foot-v3-mainbody-m">
          <div class="foot-v3-logo-m">
            <a href="https://www.cgtn.com" class="foot-v3-logo-main-m"></a>
          </div>
          <div class="foot-v3-list-site-m">
            <ul>
              <li>
                <a
                  href="https://www.cgtn.com/china"
                  class=""
                  target="_self"
                  data-category="Home"
                  data-list=""
                  data-action="Sitemap_Click"
                  data-label=""
                  data-position=""
                  data-index=""
                  data-news-id=""
                  data-time=""
                >
                  China
                </a>
              </li>
              <li>
                <a
                  href="https://www.cgtn.com/world"
                  class=""
                  target="_self"
                  data-category="Home"
                  data-list=""
                  data-action="Sitemap_Click"
                  data-label=""
                  data-position=""
                  data-index=""
                  data-news-id=""
                  data-time=""
                >
                  World
                </a>
              </li>
              <li>
                <a
                  href="https://www.cgtn.com/politics"
                  class=""
                  target="_self"
                  data-category="Home"
                  data-list=""
                  data-action="Sitemap_Click"
                  data-label=""
                  data-position=""
                  data-index=""
                  data-news-id=""
                  data-time=""
                >
                  Politics
                </a>
              </li>
              <li>
                <a
                  href="https://www.cgtn.com/business"
                  class=""
                  target="_self"
                  data-category="Home"
                  data-list=""
                  data-action="Sitemap_Click"
                  data-label=""
                  data-position=""
                  data-index=""
                  data-news-id=""
                  data-time=""
                >
                  Business
                </a>
              </li>
              <li>
                <a
                  href="https://www.cgtn.com/sci-tech"
                  class=""
                  target="_self"
                  data-category="Home"
                  data-list=""
                  data-action="Sitemap_Click"
                  data-label=""
                  data-position=""
                  data-index=""
                  data-news-id=""
                  data-time=""
                >
                  Sci-Tech
                </a>
              </li>
              <li>
                <a
                  href="https://www.cgtn.com/culture"
                  class=""
                  target="_self"
                  data-category="Home"
                  data-list=""
                  data-action="Sitemap_Click"
                  data-label=""
                  data-position=""
                  data-index=""
                  data-news-id=""
                  data-time=""
                >
                  Culture
                </a>
              </li>
              <li>
                <a
                  href="https://www.cgtn.com/sports"
                  class=""
                  target="_self"
                  data-category="Home"
                  data-list=""
                  data-action="Sitemap_Click"
                  data-label=""
                  data-position=""
                  data-index=""
                  data-news-id=""
                  data-time=""
                >
                  Sports
                </a>
              </li>
              <li>
                <a
                  href="https://www.cgtn.com/opinions"
                  class=""
                  target="_self"
                  data-category="Home"
                  data-list=""
                  data-action="Sitemap_Click"
                  data-label=""
                  data-position=""
                  data-index=""
                  data-news-id=""
                  data-time=""
                >
                  Opinions
                </a>
              </li>
              <li>
                <a
                  href="https://www.cgtn.com/travel"
                  class=""
                  target="_self"
                  data-category="Home"
                  data-list=""
                  data-action="Sitemap_Click"
                  data-label=""
                  data-position=""
                  data-index=""
                  data-news-id=""
                  data-time=""
                >
                  Travel
                </a>
              </li>
              <li>
                <a
                  href="https://www.cgtn.com/nature"
                  class=""
                  target="_self"
                  data-category="Home"
                  data-list=""
                  data-action="Sitemap_Click"
                  data-label=""
                  data-position=""
                  data-index=""
                  data-news-id=""
                  data-time=""
                >
                  Nature
                </a>
              </li>
            </ul>
            <ul>
              <li>
                <a
                  href="https://www.cgtn.com/picture"
                  class=""
                  target="_self"
                  data-category="Home"
                  data-list=""
                  data-action="Sitemap_Click"
                  data-label=""
                  data-position=""
                  data-index=""
                  data-news-id=""
                  data-time=""
                >
                  Picture
                </a>
              </li>
              <li>
                <a
                  href="https://www.cgtn.com/video"
                  class=""
                  target="_self"
                  data-category="Home"
                  data-list=""
                  data-action="Sitemap_Click"
                  data-label=""
                  data-position=""
                  data-index=""
                  data-news-id=""
                  data-time=""
                >
                  Video
                </a>
              </li>
              <li>
                <a
                  href="https://www.cgtn.com/live"
                  class=""
                  target="_self"
                  data-category="Home"
                  data-list=""
                  data-action="Sitemap_Click"
                  data-label=""
                  data-position=""
                  data-index=""
                  data-news-id=""
                  data-time=""
                >
                  Live
                </a>
              </li>
              <li>
                <a
                  href="https://radio.cgtn.com"
                  class=""
                  target="_self"
                  data-category="Home"
                  data-list=""
                  data-action="Sitemap_Click"
                  data-label=""
                  data-position=""
                  data-index=""
                  data-news-id=""
                  data-time=""
                >
                  Radio
                </a>
              </li>
              <li>
                <a
                  href="https://www.cgtn.com/specials"
                  class=""
                  target="_self"
                  data-category="Home"
                  data-list=""
                  data-action="Sitemap_Click"
                  data-label=""
                  data-position=""
                  data-index=""
                  data-news-id=""
                  data-time=""
                >
                  Specials
                </a>
              </li>
              <li>
                <a
                  href="https://www.cgtn.com/transcript"
                  class=""
                  target="_self"
                  data-category="Home"
                  data-list=""
                  data-action="Sitemap_Click"
                  data-label=""
                  data-position=""
                  data-index=""
                  data-news-id=""
                  data-time=""
                >
                  Transcript
                </a>
              </li>
              <li>
                <a
                  href="https://www.cgtn.com/europe"
                  class=""
                  target="_self"
                  data-category="Home"
                  data-list=""
                  data-action="Sitemap_Click"
                  data-label=""
                  data-position=""
                  data-index=""
                  data-news-id=""
                  data-time=""
                >
                  EUROPE
                </a>
              </li>
              <li>
                <a
                  href="https://www.cgtn.com/special/chinese-master"
                  class=""
                  target="_self"
                  data-category="Home"
                  data-list=""
                  data-action="Sitemap_Click"
                  data-label=""
                  data-position=""
                  data-index=""
                  data-news-id=""
                  data-time=""
                >
                  Learn Chinese
                </a>
              </li>
              <li>
                <a 
                  href="https://ask-china.cgtn.com/" 
                  class="" 
                  target="_self" 
                  data-category="sharePage-v3" 
                  data-action="Sitemap_Click" 
                  data-label="" 
                  data-position="" 
                  data-news-id="" 
                  data-time=""
                >
                  Ask China        
                </a>
              </li>
            </ul>
          </div>
          <div class="foot-v3-list-explore-m">
            <p class="foot-v3-list-title-m">EXPLORE MORE</p>
            <div class="foot-v3-list-explore-con-m">
              <ul>
                <li>
                  <a
                    href="https://www.cgtn.com/tv"
                    class=""
                    target="_self"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    English
                  </a>
                </li>
                <li>
                  <a
                    href="https://espanol.cgtn.com"
                    class=""
                    target="_self"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Español
                  </a>
                </li>
                <li id="language_">
                  <a
                    href="https://francais.cgtn.com"
                    class=""
                    target="_self"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Français
                  </a>
                </li>
                <li>
                  <a
                    href="https://arabic.cgtn.com"
                    class=""
                    target="_self"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    العربية
                  </a>
                </li>
              </ul>
              <ul>
                <li>
                  <a
                    href="https://russian.cgtn.com"
                    class=""
                    target="_self"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Русский
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.cgtn.com/channel/documentary"
                    class=""
                    target="_self"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Documentary
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.cctvplus.com"
                    class=""
                    target="_self"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    CCTV+
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="foot-v3-list-choose-language-m">
            <p class="choose-language-title-m">CHOOSE YOUR LANGUAGE</p>
            <div class="choose-language-con-m">
              <ul>
                <li>
                  <a
                    href="https://albanian.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Albanian</span>
                    <span class="foot-v3-language-name2-m">Shqip</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://arabic.cgtn.com"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Arabic</span>
                    <span class="foot-v3-language-name2-m">العربية</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://belarusian.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Belarusian</span>
                    <span class="foot-v3-language-name2-m">Беларуская</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://bangla.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Bengali</span>
                    <span class="foot-v3-language-name2-m">বাংলা</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://bulgarian.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Bulgarian</span>
                    <span class="foot-v3-language-name2-m">Български</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://cambodian.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Cambodian</span>
                    <span class="foot-v3-language-name2-m">ខ្មែរ</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://croatian.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Croatian</span>
                    <span class="foot-v3-language-name2-m">Hrvatski</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://czech.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Czech</span>
                    <span class="foot-v3-language-name2-m">Český</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.cgtn.com/tv"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">English</span>
                    <span class="foot-v3-language-name2-m">English</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://esperanto.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Esperanto</span>
                    <span class="foot-v3-language-name2-m">Esperanto</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://filipino.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Filipino</span>
                    <span class="foot-v3-language-name2-m">Filipino</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://francais.cgtn.com"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">French</span>
                    <span class="foot-v3-language-name2-m">Français</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://german.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">German</span>
                    <span class="foot-v3-language-name2-m">Deutsch</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://greek.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Greek</span>
                    <span class="foot-v3-language-name2-m">Ελληνικά</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://hausa.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Hausa</span>
                    <span class="foot-v3-language-name2-m">Hausa</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://hebrew.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Hebrew</span>
                    <span class="foot-v3-language-name2-m">עברית</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://hungarian.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Hungarian</span>
                    <span class="foot-v3-language-name2-m">Magyar</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://hindi.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Hindi</span>
                    <span class="foot-v3-language-name2-m">हिन्दी</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://indonesian.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Indonesian</span>
                    <span class="foot-v3-language-name2-m"
                      >Bahasa Indonesia</span
                    >
                  </a>
                </li>
                <li>
                  <a
                    href="https://italian.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Italian</span>
                    <span class="foot-v3-language-name2-m">Italiano</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://japanese.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Japanese</span>
                    <span class="foot-v3-language-name2-m">日本語</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://korean.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Korean</span>
                    <span class="foot-v3-language-name2-m">한국어</span>
                  </a>
                </li>
              </ul>
              <ul>
                <li>
                  <a
                    href="https://laos.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Lao</span>
                    <span class="foot-v3-language-name2-m">ລາວ</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://malay.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Malay</span>
                    <span class="foot-v3-language-name2-m">Bahasa Melayu</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://mongol.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Mongolian</span>
                    <span class="foot-v3-language-name2-m">Монгол</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://myanmar.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Myanmar</span>
                    <span class="foot-v3-language-name2-m">မြန်မာဘာသာ</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://nepal.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Nepali</span>
                    <span class="foot-v3-language-name2-m">नेपाली</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://persian.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Persian</span>
                    <span class="foot-v3-language-name2-m">فارسی</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://polish.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Polish</span>
                    <span class="foot-v3-language-name2-m">Polski</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://portuguese.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Portuguese</span>
                    <span class="foot-v3-language-name2-m">Português</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://pashto.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Pashto</span>
                    <span class="foot-v3-language-name2-m">پښتو</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://romanian.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Romanian</span>
                    <span class="foot-v3-language-name2-m">Română</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://russian.cgtn.com"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Russian</span>
                    <span class="foot-v3-language-name2-m">Русский</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://serbian.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Serbian</span>
                    <span class="foot-v3-language-name2-m">Српски</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://sinhala.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Sinhalese</span>
                    <span class="foot-v3-language-name2-m">සිංහල</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://espanol.cgtn.com"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Spanish</span>
                    <span class="foot-v3-language-name2-m">Español</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://swahili.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Swahili</span>
                    <span class="foot-v3-language-name2-m">Kiswahili</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://tamil.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Tamil</span>
                    <span class="foot-v3-language-name2-m">தமிழ்</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://thai.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Thai</span>
                    <span class="foot-v3-language-name2-m">ไทย</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://turkish.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Turkish</span>
                    <span class="foot-v3-language-name2-m">Türkçe</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://ukrainian.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Ukrainian</span>
                    <span class="foot-v3-language-name2-m">Українська</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://urdu.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Urdu</span>
                    <span class="foot-v3-language-name2-m">اردو</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://vietnamese.cgtn.com/"
                    class=""
                    target="_blank"
                    data-category="Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    <span class="foot-v3-language-name-m">Vietnamese</span>
                    <span class="foot-v3-language-name2-m">Tiếng Việt</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="foot-v3-list-line-m"></div>
          <div class="foot-v3-list-down-m">
            <p class="down-title-m">DOWNLOAD OUR APP</p>
            <ul>
              <li>
                <a
                  href="https://itunes.apple.com/us/app/cctvnews/id922456579"
                  class="downicon apple"
                  target="_blank"
                  data-category="Home"
                  data-list=""
                  data-action="Download_Click"
                  data-label=""
                  data-position=""
                  data-index=""
                  data-news-id=""
                  data-time=""
                >
                </a>
              </li>
              <li>
                <a
                  href="https://play.google.com/store/apps/details?id=com.imib.cctv"
                  class="downicon google"
                  target="_blank"
                  data-category="Home"
                  data-list=""
                  data-action="Download_Click"
                  data-label=""
                  data-position=""
                  data-index=""
                  data-news-id=""
                  data-time=""
                >
                </a>
              </li>
              <li>
                <a
                  href="https://news.cgtn.com/download/CGTN.apk"
                  class="downicon web"
                  target="_blank"
                  data-category="Home"
                  data-list=""
                  data-action="Download_Click"
                  data-label=""
                  data-position=""
                  data-index=""
                  data-news-id=""
                  data-time=""
                >
                </a>
              </li>
              <li>
                <a
                  href="https://www.cgtn.com/appletv-download"
                  class="downicon apple-tv"
                  target="_blank"
                  data-category="Home"
                  data-list=""
                  data-action="Download_Click"
                  data-label=""
                  data-position=""
                  data-index=""
                  data-news-id=""
                  data-time=""
                >
                </a>
              </li>
            </ul>
          </div>
          <div class="foot-v3-list-copy-m">
            <div class="foot-v3-list-items-m">
              <ul>
                <li>
                  <a
                    href="https://www.cgtn.com/terms-of-use"
                    class=""
                    target="_self"
                    data-category="Home"
                    data-list=""
                    data-action="TeamOfUs_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Terms of use
                  </a>
                  <span class="hr-r"></span>
                </li>
                <li>
                  <a
                    href="https://www.cgtn.com/copyright"
                    class=""
                    target="_self"
                    data-category="Home"
                    data-list=""
                    data-action="Copyright_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Copyright
                  </a>
                  <span class="hr-r"></span>
                </li>
                <li>
                  <a
                    href="https://www.cgtn.com/privacy"
                    class="pdr0"
                    target="_self"
                    data-category="Home"
                    data-list=""
                    data-action="PrivacyPolicy_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Privacy policy
                  </a>
                  <span class="hr-r"></span>
                </li>
                <li>
                  <a
                    href="https://www.cgtn.com/about-us"
                    class=""
                    target="_self"
                    data-category="Home"
                    data-list=""
                    data-action="AboutUs_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    About us
                  </a>
                </li>
              </ul>
            </div>
            <div class="foot-v3-copy-common-m foot-v3-copy-right-m">
              <span class="copy-right-text">Copyright © 2024 CGTN. </span>
              <a
                class="copy-right-link"
                href="http://beian.miit.gov.cn"
                target="_blank"
                >京ICP备20000184号</a
              >
            </div>
            <div class="foot-v3-copy-common-m foot-v3-anbei-m">
              <a
                href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502050052"
                target="_blank"
              >
                <img
                  src="https://ui.cgtn.com/static/ng/resource/images/gwab.png"
                  class="gwab-img-v3"
                />
                <span class="jgwab-num-v3">京公网安备 11010502050052号</span>
              </a>
            </div>
            <p class="foot-v3-copy-common-m foot-v3-copy-hotline-m">互联网新闻信息许可证10120180008</p>
            <p class="foot-v3-copy-common-m foot-v3-copy-hotline-m">
              Disinformation report hotline: 010-85061466
            </p>
            
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
      msg: 'footer'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  img{vertical-align: middle;}
</style>



// WEBPACK FOOTER //
// src/components/Footer_v3.vue